export const FINAMAZE_STANDARD_COMMISSION = 0.0085;
export const FINAMAZE_PREMIUM_COMMISSION = 0.0085;
export const FINAMAZE_VIP_COMMISSION = 0.0085;
export const FINAMAZE_PERSONALIZED_COMMISSION = 0.0085;
export const FINAMAZE_PRIVATE_COMMISSION = 0.005;
export const MIN_STANDARD_INVESTMENT = 1;
export const MIN_PREMIUM_INVESTMENT = 1;

export const MIN_WITHDRAWAL = 100;
